import { render, staticRenderFns } from "./EditAccountMail.vue?vue&type=template&id=534c2fb0&scoped=true&"
import script from "./EditAccountMail.vue?vue&type=script&lang=ts&"
export * from "./EditAccountMail.vue?vue&type=script&lang=ts&"
import style0 from "../Index.scss?vue&type=style&index=0&id=534c2fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c2fb0",
  null
  
)

export default component.exports